import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-BlockQuote" }
const _hoisted_2 = ["cite"]
const _hoisted_3 = { "txt-center": "" }
const _hoisted_4 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("figure", null, [
      _createElementVNode("blockquote", { cite: _ctx.web }, [
        _createElementVNode("p", _hoisted_3, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ], 8, _hoisted_2),
      _createElementVNode("figcaption", _hoisted_4, [
        _createTextVNode(" — " + _toDisplayString(_ctx.name) + ", ", 1),
        _createElementVNode("cite", null, [
          _renderSlot(_ctx.$slots, "cite")
        ])
      ])
    ])
  ]))
}